<script>
    import { fly } from "svelte/transition";
    import { AutoCenter } from '../index'
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">内容不够整行宽度时自动居中</h4>
    <div class="example-body">
        <AutoCenter>
            irure aliqua laborum
        </AutoCenter>
    </div>
    <h4 class="example-title">内容达到满宽后保持正常的左对齐</h4>
    <div class="example-body">
        <AutoCenter>
            Veniam cupidatat fugiat voluptate magna consequat cillum consectetur. Ex esse esse cillum dolore eu velit duis labore laborum veniam excepteur pariatur cupidatat ex. Non est qui commodo. Esse adipisicing voluptate et eiusmod magna nisi labore ad ad voluptate tempor eiusmod elit. Reprehenderit adipisicing ut esse reprehenderit dolor laborum ullamco labore nulla tempor. Consectetur velit do veniam excepteur et consequat voluptate et voluptate nostrud magna cupidatat. Ipsum aliqua Lorem non velit exercitation labore. Qui ex dolor exercitation labore. Incididunt aute culpa qui ut velit esse est exercitation proident culpa duis id officia in. Nulla sunt fugiat officia dolor ad aliqua sunt incididunt in. In reprehenderit ut et Lorem commodo consectetur cillum non voluptate aliqua sint sit ad. Amet ea aliqua pariatur adipisicing nisi esse sint occaecat consequat ullamco ipsum cupidatat excepteur ullamco ad. Ex aliqua labore ea ex quis commodo commodo nostrud id amet dolor amet consequat. Cillum commodo anim sunt amet aliquip velit amet.
        </AutoCenter>
    </div>
</div>

<style lang="less">
    @import "./example.less";
</style>
